<template>
	<div></div>
</template>
<script>
export default {};
</script>
<style >
.router-link-exact-active {
	cursor: pointer;
}
</style>
